import { useState, useContext } from 'react';
import { Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../../components";
import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap';
import Layout from '../../layout/default';
import Spinner from 'react-bootstrap/Spinner';
import { AppContext } from '../../context/AppContext';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = "HMCareTask/processrecurringtasks/";

const ProcessRecurringTask = () => {


    const {SiteConfig} = useContext(AppContext);
    const api = useApiClient();

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isProcessing, setisProcessing] = useState(false);

    const startRecurringTasksProcess = () =>{

        const frmFormData = new FormData();

        setisProcessing(true);  

         //alert(baseURL); 

        api.post(baseURL,frmFormData)        
        .then((Response)=>{
            setData(Response.data);
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

        setisProcessing(false);


    }


  return (
    <>
    <Layout title="HMCarePlanner - Settings" content="container">
    <Button variant="outline-primary" action="add" onClick={startRecurringTasksProcess}>
        <Icon name="settings"></Icon><span>Run Recurring Tasks Process</span>
    </Button>

    {isProcessing && 
      
      <Spinner animation="border" variant="primary" />
      
}
    {data && <span><br></br>Process Completed</span>}
    
    </Layout>
    </>
    
  )
}

export default ProcessRecurringTask